export default __webpack_public_path__ + "static/media/english-to-french-screenshot-03.b76d40e4.png";